import all from './all';

export default {
  all,
};



// WEBPACK FOOTER //
// ./src/app/services/paymentMethods/index.js